export default "__VITE_ASSET__31b7707d__"